const applyParamUpdates = (params: URLSearchParams, updates: Record<string, string | null>) => {
  Object.entries(updates).forEach(([key, value]) => {
    if (value === null || value === '') {
      params.delete(key)
    } else {
      params.set(key, value)
    }
  })
}

export const setQueryParams = (updates: Record<string, string | null>) => {
  const hash = window.location.hash

  if (!hash) {
    const url = new URL(window.location.href)
    applyParamUpdates(url.searchParams, updates)
    window.history.pushState({}, '', url.toString())
    return
  }

  const [hashPath, existingQuery] = hash.substring(1).split('?')
  const searchParams = new URLSearchParams(existingQuery || '')

  applyParamUpdates(searchParams, updates)

  const queryString = searchParams.toString()
  const newHash = queryString ? `#${hashPath}?${queryString}` : `#${hashPath}`

  window.location.hash = newHash
}

export const setQueryParam = (key: string, value: string | null) => {
  setQueryParams({ [key]: value })
}

export const getQueryParams = (): Record<string, string> => {
  const hash = window.location.hash

  if (!hash) {
    const params = new URLSearchParams(window.location.search)
    const result: Record<string, string> = {}
    params.forEach((value, key) => {
      result[key] = value
    })
    return result
  }

  const [, query] = hash.substring(1).split('?')
  const params = new URLSearchParams(query || '')
  const result: Record<string, string> = {}

  params.forEach((value, key) => {
    result[key] = value
  })

  return result
}
